import type { Module } from 'vuex';
import { Language } from '@/types/Language';
import {RootState} from "@/store";

export interface LanguageState {
  language: Language | null;
  deleted: boolean;
}

const languageModule: Module<LanguageState, RootState> = {
  namespaced: true,
  state: (): LanguageState => ({
    language: null,
    deleted: false,
  }),
  mutations: {
    setLanguage(state, payload: any) {
      if (payload === null || payload === undefined) {
        state.language = null;
        state.deleted = false;
        return;
      }
      state.language = Language.fromRaw(payload);
      state.deleted = false;
    },
    setLanguageUpdate(state, payload: any) {
      if (!state.language || state.language.idLanguage !== payload.idLanguage) return;
      if (payload.code !== undefined) state.language.code = payload.code;
      if (payload.selfTitle !== undefined) state.language.selfTitle = payload.selfTitle;
      if (payload.rtl !== undefined) state.language.rtl = payload.rtl;
      if (payload.locked !== undefined) state.language.locked = payload.locked;
    },
    setLanguageDelete(state, payload: { idLanguage: number }) {
      if (state.language?.idLanguage === payload.idLanguage) {
        state.deleted = true;
      }
    },
    setLanguageLock(state, payload: { idLanguage: number }) {
      if (state.language?.idLanguage === payload.idLanguage) {
        state.language.locked = true;
      }
    },

    setLanguageUnlock(state, payload: { idLanguage: number }) {
      if (state.language?.idLanguage === payload.idLanguage) {
        state.language.locked = false;
      }
    },
    clearLanguage(state) {
      state.language = null;
      state.deleted = false;
    },
  },
  actions: {
    wsSetLanguage({ commit }, payload) {
      commit('setLanguage', payload);
    },
    wsSetEmptyLanguage({ commit }) {
      commit('setLanguage', null);
    },
    wsLanguageUpdate({ commit }, payload) {
      commit('setLanguageUpdate', payload);
    },
    wsLanguageDelete({ commit }, payload) {
      commit('setLanguageDelete', payload);
    },
    wsLanguageLock({ commit }, payload) {
      commit('setLanguageLock', payload);
    },
    wsLanguageUnlock({ commit }, payload) {
      commit('setLanguageUnlock', payload);
    },
    clearLanguage({ commit }) {
      commit('clearLanguage');
    },
  },
};

export default languageModule;